import type { ReactNode } from 'react'
import { hasAuthoredIcon } from '@/lib/icons'
import { SourceMark } from './source-mark'

/**
 * What a source button shows for one source: its authored icon, or else the
 * same muted display-name text every single-source label already falls back
 * to (`SourceMark` itself renders nothing for a blank icon). Kept as one
 * fallback rather than one per surface — without it, a source with no icon
 * leaves its button (`border-0 bg-transparent p-0`, no other child) at zero
 * size: present in the DOM, invisible, and unclickable. Shared by the
 * card-details switcher, the library Source cell, and the inline card
 * switcher.
 */
export function SourceGlyph({
  icon,
  displayName,
}: {
  icon: string | null
  displayName: string
}): ReactNode {
  if (hasAuthoredIcon(icon)) return <SourceMark decorative icon={icon} />
  return (
    // `whitespace-nowrap`: this span spends its resting life inside a
    // `max-w-0 overflow-hidden` fan-out container, where wrapping text lays
    // out one character per line and silently makes the hidden state tall.
    <span className="text-[9.5px] font-semibold whitespace-nowrap text-(--cd-text-muted)">
      {displayName}
    </span>
  )
}
